import { useState, FC } from 'react';
import { Button, Tooltip } from 'antd';
import { useAppSelector } from '../../hooks';
import { taskProps, tenderDataProps } from '../../pages/TenderViewPage/types';
import { DefineQuestionnaireTask } from './DefinePhaseComponents/DefineQuestionnaireTask';
import WelcomeToDefine from '../../assets/WelcomeToDefine.svg';
import arrow from '../../assets/arrow-right-white.svg';
import attention from '../../assets/attention.svg';
import moment from 'moment';
import './phases.scss';
import { AllTasksCompleted } from './AllTasksCompleted';
import { CompletionResultModal } from '../Modals/CompletionResultModal';
import { DefineContactDetails } from './DefinePhaseComponents/DefineContactDetails';
import { DefineSiteVisitDate } from './DefinePhaseComponents/DefineSiteVisitDate';

interface PropsPhase {
    data: tenderDataProps;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    setConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DefinePhase: FC<PropsPhase> = ({ data, setTrigger, setLoading, setConfirmModal }) => {
    const { role } = useAppSelector((state: any) => state.profileReducer);
    const [isComplationModal, setIsCompetionModal] = useState(false);

    const taskHeaderDeadlineAt = role === 'school_user' ? data?.tasks_deadline_at : data?.phase_deadline_at;

    const define_phase_questionnaire = data?.phase_tasks?.find(
        (elem: taskProps) => elem.action === 'define_phase_questionnaire'
    );

    return (
        <>
            <div className={`tendermain__block tasks`}>
                <div className="tasks__header define">
                    <div className="count-wrapper">
                        Task Centre
                        <div className="count">{data?.phase_task_count}</div>
                    </div>
                    {taskHeaderDeadlineAt && (
                        <div className="tasks__deadline-wrapper">
                            <img src={attention} alt="" />
                            Task Deadline - {moment(taskHeaderDeadlineAt).format('YYYY-MM-DD')}
                        </div>
                    )}
                </div>

                {data?.phase_tasks?.length > 0 ? (
                    <div className="tasks__list">
                        {role === 'school_user' &&
                            data?.phase_tasks?.every((elem: taskProps) => elem.status === 'need_approve_tr') && (
                                <AllTasksCompleted />
                            )}

                        <DefineQuestionnaireTask data={data} role={role} setTrigger={setTrigger} />
                        <DefineContactDetails data={data} role={role} setTrigger={setTrigger} />
                        <DefineSiteVisitDate data={data} role={role} setTrigger={setTrigger} />
                    </div>
                ) : (
                    <div className="noTasks">
                        <img src={WelcomeToDefine} />
                        <div className="noTasks__title">Welcome to the Define Phase!</div>
                        <div className="noTasks__subtitle">
                            Watch this space - new tasks for you will be posted here as they become available.
                        </div>
                    </div>
                )}
                {role === 'tender_representative' && data?.phase_tasks?.length > 0 && (
                    <div className="tasks__btn-wrap">
                        <div></div>
                        <Tooltip
                            title={
                                data?.can_update_phase ? '' : 'To send this task, you need complete all Task Activities'
                            }
                            overlayClassName={` ${!data?.can_send_task ? 'custom-tooltip-disabled' : 'custom-tooltip'}`}
                        >
                            <Button
                                className={`tasks__next-btn ${data?.can_update_phase ? '' : 'disabled'}`}
                                type="primary"
                                onClick={() => {
                                    if (data?.can_update_phase) {
                                        setConfirmModal(true);
                                    } else {
                                        return;
                                    }
                                }}
                            >
                                Next Phase <img src={arrow} />
                            </Button>
                        </Tooltip>
                    </div>
                )}
                {role === 'school_user' && (
                    <div className="tasks__btn-wrap">
                        <div></div>
                        <Tooltip
                            title={
                                data?.can_send_task
                                    ? ''
                                    : data?.phase_tasks?.find((elem) => elem.action === 'define_phase_questionnaire')
                                          ?.status === 'need_approve_tr'
                                    ? ''
                                    : 'To Send Task, you need to Complete all activities'
                            }
                        >
                            <Button
                                className={`tasks__next-btn ${!data?.can_send_task ? 'disabled' : ''}`}
                                type="primary"
                                onClick={() => {
                                    if (data?.can_send_task) {
                                        setIsCompetionModal(true);
                                    }
                                }}
                            >
                                <div className="flex">
                                    Submit <img src={arrow} style={{ margin: '0 0 0 10px' }} />
                                </div>
                            </Button>
                        </Tooltip>
                    </div>
                )}
            </div>

            {isComplationModal && (
                <CompletionResultModal
                    openModal={isComplationModal}
                    setOpenModal={setIsCompetionModal}
                    data={data}
                    setTrigger={setTrigger}
                />
            )}
        </>
    );
};
